import type * as THREE from "three";

function isPointInPolygonXZ(point: THREE.Vector3, polygon: ReadonlyArray<THREE.Vector3>): boolean {
	if (polygon.length < 3) {
		return false;
	}

	const { x, z } = point;
	let inside = false;

	for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
		const xi = polygon[i].x;
		const zi = polygon[i].z;
		const xj = polygon[j].x;
		const zj = polygon[j].z;

		const intersects = zi > z !== zj > z && x < ((xj - xi) * (z - zi)) / (zj - zi) + xi;

		if (intersects) {
			inside = !inside;
		}
	}

	return inside;
}

export { isPointInPolygonXZ };
